import React, {useEffect, useState} from "react";
import {useToast} from "./ToastContext";
import {Incarico} from "../types";
import {Timer} from "lucide-react";

const SessionTimer: React.FC<{ startTimestamp?: string }> = ({ startTimestamp }) => {
    const [seconds, setSeconds] = useState(0);
    useEffect(() => {
        if (!startTimestamp) return;
        const start = new Date(startTimestamp).getTime();
        const interval = setInterval(() => {
            setSeconds(Math.floor((Date.now() - start) / 1000));
        }, 1000);
        return () => clearInterval(interval);
    }, [startTimestamp]);

    const formatTime = (s: number) => {
        const h = Math.floor(s / 3600);
        const m = Math.floor((s % 3600) / 60);
        const sec = s % 60;
        return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
    };

    return (
        <div className="font-mono text-4xl sm:text-5xl font-medium tracking-tight text-emerald-400 flex items-center justify-center gap-3 bg-slate-900/50 p-6 rounded-2xl border border-slate-700/50 shadow-inner">
            <Timer size={32} className="animate-pulse opacity-70" />
            {formatTime(seconds)}
        </div>
    );
};

export default SessionTimer